// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".gifts-how-it-works__stars[data-v-042954c3]{position:absolute;top:40px;right:180px;width:230px}@media(min-width:768px)and (max-width:991px){.gifts-how-it-works__stars[data-v-042954c3]{width:120px;top:48px;right:48px}}@media(min-width:0)and (max-width:767px){.gifts-how-it-works__stars[data-v-042954c3]{width:90px;top:24px;right:24px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
